import { motion } from 'motion/react';
import { theme } from '../styles/theme';

const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

interface ActivityMapProps {
  location: string;
  destination?: string;
  placeId?: string;
}

function buildQuery(location: string, destination?: string): string {
  return destination ? `${location}, ${destination}` : location;
}

export function ActivityMap({ location, destination, placeId }: ActivityMapProps) {
  if (!GOOGLE_MAPS_API_KEY) return null;

  const query = buildQuery(location, destination);
  const embedSrc = placeId
    ? `https://www.google.com/maps/embed/v1/place?key=${GOOGLE_MAPS_API_KEY}&q=place_id:${placeId}`
    : `https://www.google.com/maps/embed/v1/place?key=${GOOGLE_MAPS_API_KEY}&q=${encodeURIComponent(query)}`;

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, ease: [0.23, 1, 0.32, 1] }}
      style={{ paddingTop: theme.spacing.xl }}
    >
      <div style={{
        borderRadius: theme.borderRadius['2xl'],
        overflow: 'hidden',
        border: `1px solid ${theme.colors.borderLight}`,
        boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.04)',
        position: 'relative',
      }}>
        <iframe
          title={`Map of ${location}`}
          src={embedSrc}
          width="100%"
          height="256"
          style={{ border: 0, display: 'block' }}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          allowFullScreen
        />
        <div style={{
          position: 'absolute', inset: 0, pointerEvents: 'none',
          border: '2px solid transparent', borderRadius: theme.borderRadius['2xl'],
          transition: 'border-color 0.3s ease',
        }} data-map-overlay />
      </div>
    </motion.div>
  );
}
